import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NotifyForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/notify`, { email: email.trim() });
      setRegistered(true);
      toast.success("Signal registered. You will be the first to know.");
    } catch (err) {
      if (err.response?.status === 409) {
        toast.info("This signal is already registered.");
        setRegistered(true);
      } else if (err.response?.status === 422) {
        toast.error("That does not look like a valid email.");
      } else {
        toast.error("Transmission failed. Try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="notify" className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        data-testid="notify-form"
        className="max-w-xl mx-auto bg-[#0c0c14] border border-[#00f0ff]/20 p-8 sm:p-12 rounded-2xl relative overflow-hidden"
      >
        <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-[#00f0ff]/10 blur-3xl pointer-events-none" />
        <p className="text-xs font-mono-z uppercase tracking-[0.4em] text-[#00f0ff] mb-4">[ Priority Access ]</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight mb-3">Be the first to know</h2>
        <p className="text-sm text-[#8e8ea0] font-mono-z mb-8 leading-relaxed">
          Leave your email. When the silence breaks, you hear it before anyone else.
        </p>

        {registered ? (
          <div data-testid="notify-success" className="border border-[#00f0ff]/40 bg-[#00f0ff]/5 p-5 text-center">
            <p className="font-mono-z text-sm text-[#00f0ff] uppercase tracking-[0.2em]">✓ Signal Registered</p>
            <p className="text-xs text-[#8e8ea0] mt-2 font-mono-z">Stand by for transmission.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
            <input
              data-testid="notify-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-[#030305] border border-white/15 px-5 py-4 text-sm font-mono-z text-[#f8f9fa] placeholder:text-[#8e8ea0]/50 outline-none transition-colors duration-300 focus:border-[#00f0ff]/60"
            />
            <button
              data-testid="notify-submit-btn"
              type="submit"
              disabled={loading}
              className="bg-[#00f0ff] text-[#030305] font-mono-z font-bold uppercase tracking-[0.2em] text-xs px-8 py-4 transition-opacity duration-300 hover:opacity-85 disabled:opacity-50"
            >
              {loading ? "Sending..." : "Notify Me"}
            </button>
          </form>
        )}
      </motion.div>
    </section>
  );
};

export default NotifyForm;
